import { render } from "./settings_user_management_alerts.html?vue&type=template&id=9111e834&external"
import script from "./settings_user_management_alerts.js?vue&type=script&lang=js&external"
export * from "./settings_user_management_alerts.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__